import { rand, randAlphaNumeric, randAccount, randCompanyName } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { MockBillingParty } from '@library/common/models/mock';

import { Leg } from '../cartage-leg';

export class MockLeg extends Leg {
   constructor() {
      super({
         carrier: randCompanyName(),
         proNumber: randAlphaNumeric({ length: 12 }).join(''),
         serviceLevel: rand([ 'Next Day', 'White Glove', '4 Day', '3-5 Deferred Day' ]),
      });

      if ( optional() ) { this.accountNumber = randAccount(); }

      if ( optional() ) { this.shipper = new MockBillingParty(); }
      if ( optional() ) { this.consignee = new MockBillingParty(); }
   }
}
